import { useEffect, useRef, useState } from "react";

// The canonical μ-limit shown across the page. Keep in sync with the copy.
const LIMIT = 512;

const PHRASES = [
  "Some days the whole point fits in one line.",
  "Wrote a novel in my head. Posted the best sentence.",
  "μικρό is not a limit. It's a filter.",
  "Less feed. More letters.",
];

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

/**
 * Live "someone is typing" composer card. Types each phrase out character by
 * character, holds, deletes, and cycles. Honors prefers-reduced-motion by
 * showing a single static phrase with no animation.
 */
export default function Composer() {
  const [text, setText] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    if (prefersReducedMotion()) {
      setText(PHRASES[0] ?? "");
      return;
    }

    let phrase = 0;
    let chars = 0;
    let deleting = false;
    let cancelled = false;

    const tick = () => {
      if (cancelled) return;
      const p = PHRASES[phrase] ?? "";
      setText(p.slice(0, chars));

      if (!deleting) {
        chars++;
        if (chars > p.length) {
          deleting = true;
          timer.current = setTimeout(tick, 1700); // hold the finished phrase
          return;
        }
      } else {
        chars--;
        if (chars < 0) {
          deleting = false;
          chars = 0;
          phrase = (phrase + 1) % PHRASES.length;
        }
      }
      // human-ish cadence: quick deletes, slightly varied typing
      timer.current = setTimeout(tick, deleting ? 26 : 48 + Math.random() * 46);
    };

    tick();
    return () => {
      cancelled = true;
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return (
    <figure className="composer" aria-hidden="true">
      <div className="top">
        <b>bobru.net/@you</b>
        <span>
          {text.length} / {LIMIT}
        </span>
      </div>
      <p className="prompt">@you is writing…</p>
      <p className="post-txt">
        <span>{text}</span>
        <span className="cur"></span>
      </p>
      <div className="bot">
        <span>say less, mean more</span>
        <a className="btn btn-solid" href="#claim" style={{ padding: "9px 18px" }}>
          Post
        </a>
      </div>
    </figure>
  );
}
